import { isNumber } from "@tiptap/core";

export function getIconSize(iconSize) {
  return isNumber(iconSize)
    ? iconSize
    : iconSize === "small"
      ? 16
      : iconSize === "large"
        ? 32
        : iconSize === "extralarge"
          ? 48
          : 24;
}
